import { getDefaultKeyBinding, KeyBindingUtil } from "draft-js";
const { hasCommandModifier } = KeyBindingUtil;
import { KEY_COMMANDS } from "config/constants/editor";

export default function keyBindingFn(e) {
  if (e.keyCode === 75 /* `K` key */ && hasCommandModifier(e)) {
    return KEY_COMMANDS.LINK;
  }
  return getDefaultKeyBinding(e);
}
